import { apiPaths, getApiPath, httpStatus } from '../../constants'
import { Api } from '../../middlewares'
import { Logger, LoggerTypes } from '../../utils'

// -- GET
export const GET_GLOBAL_WEATHER_DATAS_SUCCESS = 'GET_GLOBAL_WEATHER_DATAS_SUCCESS'
export const GET_GLOBAL_WEATHER_DATAS_FAILURE = 'GET_GLOBAL_WEATHER_DATAS_FAILURE'

// -- CREATE
export const CREATE_GLOBAL_WEATHER_DATA_SUCCESS = 'CREATE_GLOBAL_WEATHER_DATA_SUCCESS'
export const CREATE_GLOBAL_WEATHER_DATA_FAILURE = 'CREATE_GLOBAL_WEATHER_DATA_FAILURE'

// -- UPDATE
export const UPDATE_GLOBAL_WEATHER_DATA_SUCCESS = 'UPDATE_GLOBAL_WEATHER_DATA_SUCCESS'
export const UPDATE_GLOBAL_WEATHER_DATA_FAILURE = 'UPDATE_GLOBAL_WEATHER_DATA_FAILURE'

// -- DELETE
export const DELETE_GLOBAL_WEATHER_DATA_SUCCESS = 'DELETE_GLOBAL_WEATHER_DATA_SUCCESS'
export const DELETE_GLOBAL_WEATHER_DATA_FAILURE = 'DELETE_GLOBAL_WEATHER_DATA_FAILURE'

// -- SELECT
export const SELECT_GLOBAL_WEATHERS = 'SELECT_GLOBAL_WEATHERS'

// ---------------------------------------------------------------------------

/**
 * GET the list of all global weather's attributes objects.
 *
 * @returns {Promise<array<object>>}
 */
export const getGlobalWeathers = () => async (dispatch) => {
  const path = apiPaths.GLOBAL_WEATHER_DATA_LIST
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalWeathersActions.getGlobalWeathers()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_GLOBAL_WEATHER_DATAS_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_GLOBAL_WEATHER_DATAS_FAILURE,
    data: result.data
  })
}

/**
 * CREATE a new global weather's attribute.
 *
 * @param {object} newWeather New global weather's attribute object to create.
 * @param {func} _onUploadProgress on upload data function.
 * @returns {Promise<object>}
 */
export const createGlobalWeather = (newWeather, _onUploadProgress) => async (dispatch) => {
  // _onDownloadProgress
  const path = apiPaths.GLOBAL_WEATHER_DATA_CREATE
  const api = new Api(path)
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: (progressEvent) => {
      const _progress = (progressEvent.loaded / progressEvent.total) * 50
      if (_onUploadProgress) {
        _onUploadProgress(_progress)
      }
    }
    // onDownloadProgress: (progressEvent) => {
    //   const _progress = 50 + (progressEvent.loaded / progressEvent.total) * 50
    //   _onDownloadProgress(_progress)
    // }
  }
  const result = await api.create(newWeather, config)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalWeathersActions.createGlobalWeather()', { path, newWeather, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_GLOBAL_WEATHER_DATA_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_GLOBAL_WEATHER_DATA_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific global weather's attribute based on its weather ID
 *
 * @param {object} newWeather Object to set instead of the previous one.
 * @param {uui} wid Global weather UUID to update.
 * @param {func} _onUploadProgress on upload data function.
 * @returns {object}
 */
export const updateGlobalWeather = (newWeather, wid, _onUploadProgress) => async (dispatch) => {
  const path = getApiPath(apiPaths.GLOBAL_WEATHER_DATA_UPDATE, { wid })
  const api = new Api(path)
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: (progressEvent) => {
      const _progress = (progressEvent.loaded / progressEvent.total) * 50
      _onUploadProgress(_progress)
    }
    // onDownloadProgress: (progressEvent) => {
    //   const _progress = 50 + (progressEvent.loaded / progressEvent.total) * 50
    //   _onDownloadProgress(_progress)
    // }
  }
  const result = await api.update(newWeather, config)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalWeathersActions.updateGlobalWeather()', { path, newWeather, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_GLOBAL_WEATHER_DATA_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_GLOBAL_WEATHER_DATA_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific global weather's attribute based on its weather ID.
 *
 * @param {uuid} wid Global weather UUID to delete.
 * @returns {Promise<uuid>}
 */
export const deleteGlobalWeather = (wid) => async (dispatch) => {
  const path = getApiPath(apiPaths.GLOBAL_WEATHER_DATA_DELETE, { wid })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalWeathersActions.deleteGlobalWeather()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_GLOBAL_WEATHER_DATA_SUCCESS,
      data: wid
    })
  }
  return dispatch({
    type: DELETE_GLOBAL_WEATHER_DATA_FAILURE,
    data: result.data
  })
}

/**
 * SELECT a list of weather ID.
 *
 * @param {array<uuid>} data Array of global weather UUID to select.
 * @returns {Promise<object>}
 */
export const selectListGlobalWeathers = (data) => async (dispatch) => {
  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalWeathersActions.selectListGlobalWeathers()', { data })
  return dispatch({
    type: SELECT_GLOBAL_WEATHERS,
    data
  })
}

/**
 * Download a global weather file.
 *
 * @param {object} weather object to be downloaded.
 * @returns {Promise<object>}
 */
export const downloadGlobalWeather = (weather) => async () => {
  const path = getApiPath(apiPaths.GLOBAL_WEATHER_DATA_DOWNLOAD, { wid: weather.id })
  const filename = `${weather.filename}`
  const api = new Api(path)
  const result = await api.download(filename)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalWeathersActions.downloadGlobalWeather()', {
    path,
    weather,
    filename,
    result
  })
}
